import Pickr from '@simonwep/pickr/dist/pickr.es5.min.js';

window.Pickr = Pickr;
